var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.249918 9.41662C0.0971405 9.26385 0.020752 9.0694 0.020752 8.83329C0.020752 8.59718 0.0971405 8.40274 0.249918 8.24996L3.49992 4.99996L0.249918 1.74996C0.0971405 1.59718 0.020752 1.40274 0.020752 1.16663C0.020752 0.930515 0.0971405 0.73607 0.249918 0.583292C0.402696 0.430515 0.59714 0.354126 0.833252 0.354126C1.06936 0.354126 1.26381 0.430515 1.41659 0.583292L5.24992 4.41663C5.33325 4.49996 5.39242 4.59024 5.42742 4.68746C5.46186 4.78468 5.47909 4.88885 5.47909 4.99996C5.47909 5.11107 5.46186 5.21524 5.42742 5.31246C5.39242 5.40968 5.33325 5.49996 5.24992 5.58329L1.41659 9.41662C1.26381 9.5694 1.06936 9.64579 0.833252 9.64579C0.59714 9.64579 0.402696 9.5694 0.249918 9.41662Z",
    fill: "#908E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.11ce0ccd102a73e693c741fbf45e9c57.svg";
export { ForwardRef as ReactComponent };